export const INVALID_INPUT_MESSAGE = 'Invalid Input';
